module.exports = {
  BUSINESS_IMPRESSIONS_DESKTOP_MAPS: 1,
  BUSINESS_IMPRESSIONS_DESKTOP_SEARCH: 2,
  BUSINESS_IMPRESSIONS_MOBILE_MAPS: 3,
  BUSINESS_IMPRESSIONS_MOBILE_SEARCH: 4,
  BUSINESS_CONVERSATIONS: 5,
  BUSINESS_DIRECTION_REQUESTS: 6,
  CALL_CLICKS: 7,
  WEBSITE_CLICKS: 8,
  BUSINESS_BOOKINGS: 9,
  BUSINESS_FOOD_ORDERS: 10
};
